import { TeamPlanTier } from "@alch/dx-entities";
import { PlanSelection } from "@features/signup/Pages/PlanPage";
import { SUBSCRIPTION_TIER_LABELS } from "@util/constants";
import clsx from "clsx";

interface PlanSelectionCardProps {
  plan: PlanSelection;
  onClick: () => void;
  isSelected: boolean;
}

const PlanSelectionCard = ({
  plan: { subtitle, tier, monthlyPrice, valueProps, poweringTeamsLogos },
  onClick,
  isSelected,
}: PlanSelectionCardProps) => {
  return (
    <div
      className={clsx(
        "cursor-pointer rounded-[24px]",
        isSelected
          ? "m-0 border-[3px] border-blue-400"
          : "m-[2px] border border-grayscale-200",
      )}
      onClick={onClick}
    >
      <div
        className={clsx(
          " bg-white px-6 pt-6",
          tier !== TeamPlanTier.SCALE && "rounded-t-[24px]",
          tier === TeamPlanTier.SCALE &&
            "border-t-DEFAULT border-grayscale-200",
        )}
      >
        <div
          className={clsx(
            "text-heading-h2 text-grayscale-950",
            isSelected && "text-blue-600",
          )}
        >
          {SUBSCRIPTION_TIER_LABELS[tier]}
        </div>
        <div className="h-1"></div>
        <div className="text-paragraph-200-regular text-grayscale-500">
          {subtitle}
        </div>
        <div className="h-5" />
        <div className="flex items-end">
          <div
            className={clsx(
              "text-[2.5rem] font-semibold leading-tight text-grayscale-950",
              isSelected && "text-blue-600",
            )}
          >
            {monthlyPrice}
          </div>
          {tier != TeamPlanTier.ENTERPRISE && (
            <div className="ml-1 text-heading-h4 text-grayscale-500">/mo</div>
          )}
        </div>
        <div
          className={clsx(
            "grid grid-rows-2 gap-y-1 py-5",
            isSelected && "text-blue-600",
          )}
        >
          {valueProps.map((valueProp) => valueProp)}
        </div>
      </div>
      <div className="rounded-b-[24px] bg-grayscale-50 px-6 pb-6">
        <div className="py-4 text-paragraph-200-regular text-grayscale-500">
          Powering teams like
        </div>
        <div className="flex">
          {poweringTeamsLogos.map((logoUrl, index) => (
            <img key={index} src={logoUrl} style={{ width: 90, height: 28 }} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanSelectionCard;
